import * as yup from 'yup'
import { defineMessages } from 'react-intl'

const chargeIdMessages = defineMessages({
  required: {
    id: 'bookings.chargeId.required',
    defaultMessage: 'The charge id is required'
  }
})

export const schema = (intl: TSFixMe): TSFixMe => {
  return yup.object().shape({
    chargeId: yup.string().required(intl.formatMessage(chargeIdMessages.required))
  })
}
